import * as Yup from 'yup';

export const loginValidationSchema = Yup.object({
  email: Yup.string()
    .required('Email is required')
    .email('Please enter a valid email address'),
  password: Yup.string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters'),
  rememberMe: Yup.boolean().optional(),
});

export const forgotPasswordValidationSchema = Yup.object({
  mobile: Yup.string()
    .required('Email/Mobile is required')
    .test('email-or-mobile', 'Please enter a valid email or mobile number', (value) => {
      if (!value) return false;
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[0-9]{10}$/;
      
      return emailRegex.test(value) || mobileRegex.test(value);
    }),
});

export const resetPasswordValidationSchema = Yup.object({
  newPassword: Yup.string()
    .required('New password is required')
    .min(6, 'Password must be at least 6 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      'Password must contain at least one uppercase letter, one lowercase letter, and one number'
    ),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
});

export const profileValidationSchema = Yup.object({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must be less than 50 characters'),
  email: Yup.string()
    .required('Email is required')
    .email('Please enter a valid email address'),
  designation: Yup.string()
    .required('Designation is required')
    .min(2, 'Designation must be at least 2 characters')
    .max(100, 'Designation must be less than 100 characters'),
  city: Yup.string()
    .required('City is required')
    .min(2, 'City must be at least 2 characters')
    .max(50, 'City must be less than 50 characters'),
  state: Yup.string()
    .required('State is required')
    .min(2, 'State must be at least 2 characters')
    .max(50, 'State must be less than 50 characters'),
whatsappNumber: Yup.string()
  .required('WhatsApp Number is required')
  .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit WhatsApp number'),

  aboutMe: Yup.string()
    .max(500, 'About me must be less than 500 characters'),
  socialMediaLinks: Yup.array()
    .of(
      Yup.string()
        .url('Please enter a valid URL')
        .matches(
          /^https?:\/\/(www\.)?(facebook|twitter|linkedin|instagram|github|youtube)\.com\/.+/,
          'Please enter a valid social media URL'
        )
    )
    .max(5, 'Maximum 5 social media links allowed'),
});

export const registerValidationSchema = Yup.object({
  name: Yup.string()
    .required('Full Name is required')
    .min(2, 'FullName must be at least 2 characters')
    .max(50, 'FullName must be less than 50 characters'),
  email: Yup.string()
    .required('Email is required')
    .email('Please enter a valid email address'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    ),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
  designation: Yup.string()
    .required('Designation is required'),
      gender: Yup.string()
    .required('Gender is required'),
  city: Yup.string()
    .required('City is required')
    .min(2, 'City must be at least 2 characters')
    .max(50, 'City must be less than 50 characters'),
  state: Yup.string()
    .required('State is required')
    .min(2, 'State must be at least 2 characters')
    .max(50, 'State must be less than 50 characters'),
    whatsappNumber: Yup.string()
  .required('WhatsApp Number is required')
  .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit WhatsApp number'),

  // whatsappNumber: Yup.string()
  //   .required('WhatsApp Number is required')
  //   .matches(
  //     /^\+?[1-9]\d{1,14}$/,
  //     'Please enter a valid WhatsApp number with country code'
  //   ),
});